import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import getSurfaceStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

const updateSelectedDate = mutatorAction('updateSelectedDate', (date: OwaDate) => {
    const store: CalendarSurfaceStore = getSurfaceStore();
    store.selectedDate = date;
    store.dateToNavigate = date;
});

export default updateSelectedDate;
